import { useState } from "react";
import { useApp } from "../context";
import { api, apiError } from "../lib/api";

export default function ChangePassword() {
  const { notify, closeModal } = useApp();
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(e.target));
    if (f.new_password !== f.confirm) return setError("New passwords do not match.");
    if (f.new_password.length < 8) return setError("New password must be at least 8 characters.");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      closeModal();
      notify("Password changed. Use it next time you sign in.");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <h2>Change password</h2>
      <p className="muted">Enter your current password, then choose a new one of at least 8 characters.</p>
      <form noValidate onSubmit={submit} data-testid="change-password-form">
        <div className="formgrid">
          <label className="full">Current password
            <input name="current_password" type="password" required autoComplete="current-password" data-testid="current-password-input" />
          </label>
          <label>New password
            <input name="new_password" type="password" required minLength={8} autoComplete="new-password" data-testid="new-password-input" />
          </label>
          <label>Confirm new password
            <input name="confirm" type="password" required minLength={8} autoComplete="new-password" data-testid="confirm-password-input" />
          </label>
        </div>
        {error && <div className="notice warning space" role="alert" data-testid="change-password-error">{error}</div>}
        <div className="footer">
          <button type="button" onClick={closeModal} data-testid="change-password-cancel-btn">Cancel</button>
          <button type="submit" className="primary" disabled={busy} data-testid="change-password-save-btn">
            {busy ? "Saving…" : "Change password"}
          </button>
        </div>
      </form>
    </>
  );
}
